import apiClient from '../api';

export interface ExerciseLibraryEntry {
  exerciseLibraryId: string;
  name: string;
  muscleGroup: string;
  equipment: string | null;
  description: string | null;
  imageUrl: string | null;
  videoUrl: string | null;
}

const BASE = '/exercise-library';

/**
 * Fetch the full exercise library.
 * The frontend loads this once per session and filters client-side for instant autocomplete.
 *
 * Future caching note: this endpoint is a good Redis candidate on the backend side
 * once concurrent usage warrants it. Zero frontend changes would be required.
 */
export const getExerciseLibrary = (): Promise<ExerciseLibraryEntry[]> =>
  apiClient.get(BASE).then(r => r.data);

/** Convenience: distinct muscle group names in alphabetical order. */
export const getMuscleGroups = (): Promise<string[]> =>
  apiClient.get(`${BASE}/muscle-groups`).then(r => r.data);
